import {
  Button,
  Col,
  Empty,
  message,
  Modal,
  Row,
  Space,
  Spin,
  Table,
} from "antd";
import { columnProduct } from "../common/columns";
import { useEffect, useState } from "react";
import AddProduct from "./content/Add";
import { deleteProduct, getAllProducts } from "../../../api/product/api";
import dayjs from "dayjs";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const ProductDentistry = () => {
  const [isVisible, setIsvisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!isVisible) getData();
  }, [isVisible]);

  function getData() {
    setLoading(true);
    getAllProducts()
      .then((res) => {
        setDataSource(mapDataSource(res?.data));
      })
      .finally(() => setLoading(false));
  }

  const mapDataSource = (values) => {
    return values?.map((item) => ({
      ...item,
      key: item.id,
      createDate: dayjs(item.createdAt).format("DD-MM-YYYY"),
      menu: (
        <>
          <Row gutter={12} justify={"end"} align={"middle"}>
            <Col>
              <EditOutlined
                onClick={() => {
                  setData(item);
                  setIsvisible(true);
                }}
              />
            </Col>
            <Col>
              <DeleteOutlined onClick={() => confirmDelete(item.id)} />
            </Col>
          </Row>
        </>
      ),
    }));
  };

  function confirmDelete(id) {
    Modal.confirm({
      title: "Xác nhận",
      content: "Bạn có chắc là muốn xóa sản phẩm này không?",
      okText: <div style={{ color: "white" }}>Xóa</div>,
      okButtonProps: {
        className: "bg-admin-btn-primary",
      },
      onOk: () => {
        setLoading(true);
        deleteProduct(id).then((res) => {
          message.success("Xóa sản phẩm thành công");
          getData();
        });
      },
    });
  }

  const locale = {
    emptyText: (
      <Space direction="vertical" align="center" style={{ marginTop: "20px" }}>
        <Empty description={"Chưa có dữ liệu sản phẩm"} />
      </Space>
    ),
  };

  return (
    <>
      <div style={{ padding: "10px" }}>
        <Button type="dashed" onClick={() => setIsvisible(true)}>
          Tạo mới sản phẩm
        </Button>
      </div>
      <Spin tip="Xin vui lòng chờ..." spinning={loading}>
        <Table
          columns={columnProduct}
          dataSource={dataSource}
          locale={locale}
        />
      </Spin>
      <AddProduct
        isVisible={isVisible}
        onCancel={() => {
          setIsvisible(false);
          setData(null);
        }}
        data={data}
      />
    </>
  );
};
export default ProductDentistry;
